import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/unittitle/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/unittitle/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.unittitle.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveUnitTitleAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_TITLE_ASYNC, vo });

            EditService.saveUnitTitle(
                vo,
                response => {
                    dispatch(Actions.saveUnitTitleSuccess(response));
                },
                error => {
                    dispatch(Actions.saveUnitTitleFailure(error));
                }
            );
        };
    },

    saveUnitTitleSuccess: data => ({
        type: ActionTypes.SAVE_UNIT_TITLE_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_TITLE_ASYNC,
        data
    }),

    saveUnitTitleFailure: error => ({
        type: ActionTypes.SAVE_UNIT_TITLE_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_TITLE_ASYNC,
        error
    }),

    createUnitTitle: () => ({
        type: ActionTypes.CREATE_UNIT_TITLE
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    unitTitle: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, unitTitle: data.unitTitle };
};


const createunitTitleReducer = (state) => {
    return { ...state, unitTitle: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_TITLE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_TITLE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_TITLE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_UNIT_TITLE]: createunitTitleReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
